import { FieldValues } from 'react-hook-form';
import { FormContainer, FormContainerProps } from 'react-hook-form-mui';
import { Box, Button, Container, FormHelperText, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootContainer = styled(Container)(({ theme }) => ({
    minHeight: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(0),
}));

export const Footer = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(5),
}));

export const FormError = ({ status }: { status: string }) => {
    if (!status) {
        return null;
    }

    return (
        <Box display="flex" justifyContent="center">
            <FormHelperText error>{status}</FormHelperText>
        </Box>
    );
};

export function StyledForm<T extends FieldValues>(
    props: FormContainerProps<T>
) {
    return (
        <FormContainer
            FormProps={{
                style: { width: '100%' },
            }}
            {...props}
        />
    );
}
